// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { PageInfoFragment } from '../../../../graphql/fragments/pageInfo.fragment.generated';
import { AiOnboardingModal_AiSuggestionFragment, AiOnboardingModal_AiSuggestionFormDataFragment, AiOnboardingModal_HouseholdFragment } from './aiOnboardingModal.generated';
import { CommonAiSuggestionEvidenceFragment, ReferenceAiOnboardingSuggestionFragment } from '../../../aiSuggestions/graphql/aiSuggestions.generated';
import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../../../graphql/fragments/pageInfo.fragment.generated';
import { AiOnboardingModal_AiSuggestionFragmentDoc, AiOnboardingModal_AiSuggestionFormDataFragmentDoc, AiOnboardingModal_HouseholdFragmentDoc } from './aiOnboardingModal.generated';
import { CommonAiSuggestionEvidenceFragmentDoc, ReferenceAiOnboardingSuggestionFragmentDoc } from '../../../aiSuggestions/graphql/aiSuggestions.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchAiOnboardingModalDataV2QueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
  suggestionsWhere: Types.AiSuggestionWhereInput;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;


export type FetchAiOnboardingModalDataV2Query = { __typename?: 'Query', aiSuggestions: { __typename?: 'AISuggestionConnection', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & PageInfoFragment
    ), edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion', id: string }
        & AiOnboardingModal_AiSuggestionFragment
      ) | null } | null> | null }, households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & AiOnboardingModal_HouseholdFragment
      ) | null } | null> | null } };

export type FetchAiOnboardingModalAllSuggestionsV2QueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
  suggestionsWhere: Types.AiSuggestionWhereInput;
}>;


export type FetchAiOnboardingModalAllSuggestionsV2Query = { __typename?: 'Query', aiSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion', id: string, evidence?: Array<(
          { __typename?: 'AISuggestionEvidence' }
          & CommonAiSuggestionEvidenceFragment
        )> | null }
        & AiOnboardingModal_AiSuggestionFormDataFragment
      ) | null } | null> | null } };

export type AiOnboardingModal_Kgv2PrincipalNodeFragment = { __typename?: 'KGV2Node', id: string, nodeType: Types.Kgv2NodeNodeType, namePrimary: string, resolvedEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null }, resolvedClientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: { __typename?: 'ClientProfile', id: string, displayName: string } | null } | null> | null }, resolvedClientOrganizations: { __typename?: 'ClientOrganizationConnection', edges?: Array<{ __typename?: 'ClientOrganizationEdge', node?: { __typename?: 'ClientOrganization', id: string, name: string } | null } | null> | null }, resolvedTestamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: { __typename?: 'TestamentaryEntity', id: string, displayName: string } | null } | null> | null }, onboardingSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind } | null } | null> | null } };

export type FetchOnboardingPrincipalNodesQueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
  nodeIDs: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type FetchOnboardingPrincipalNodesQuery = { __typename?: 'Query', fetchHouseholdKGV2Nodes: Array<(
    { __typename?: 'KGV2Node' }
    & AiOnboardingModal_Kgv2PrincipalNodeFragment
  )> };

export const Operations = {
  Query: {
    FetchAIOnboardingModalDataV2: 'FetchAIOnboardingModalDataV2' as const,
    FetchAIOnboardingModalAllSuggestionsV2: 'FetchAIOnboardingModalAllSuggestionsV2' as const,
    FetchOnboardingPrincipalNodes: 'FetchOnboardingPrincipalNodes' as const
  },
  Fragment: {
    AIOnboardingModal_KGV2PrincipalNode: 'AIOnboardingModal_KGV2PrincipalNode' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AiOnboardingModal_Kgv2PrincipalNodeFragmentDoc = gql`
    fragment AIOnboardingModal_KGV2PrincipalNode on KGV2Node {
  id
  nodeType
  namePrimary
  resolvedEntities {
    edges {
      node {
        id
        kind
        subtype {
          id
          displayName
        }
      }
    }
  }
  resolvedClientProfiles {
    edges {
      node {
        id
        displayName
      }
    }
  }
  resolvedClientOrganizations {
    edges {
      node {
        id
        name
      }
    }
  }
  resolvedTestamentaryEntities {
    edges {
      node {
        id
        displayName
      }
    }
  }
  onboardingSuggestions {
    edges {
      node {
        id
        kind
      }
    }
  }
}
    `;
export const FetchAiOnboardingModalDataV2Document = gql`
    query FetchAIOnboardingModalDataV2($householdID: ID!, $suggestionsWhere: AISuggestionWhereInput!, $first: Int!, $after: Cursor) {
  aiSuggestions(
    where: {and: [{hasHouseholdWith: [{id: $householdID}], version: 2, kindNotIn: [ONBOARDING_INDIVIDUAL, ONBOARDING_ORGANIZATION]}, $suggestionsWhere]}
    orderBy: {field: created_at, direction: DESC}
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        id
        ...AIOnboardingModal_AISuggestion
      }
    }
  }
  households(where: {id: $householdID}) {
    edges {
      node {
        ...AIOnboardingModal_Household
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${AiOnboardingModal_AiSuggestionFragmentDoc}
${AiOnboardingModal_HouseholdFragmentDoc}`;

/**
 * __useFetchAiOnboardingModalDataV2Query__
 *
 * To run a query within a React component, call `useFetchAiOnboardingModalDataV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFetchAiOnboardingModalDataV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAiOnboardingModalDataV2Query({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      suggestionsWhere: // value for 'suggestionsWhere'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchAiOnboardingModalDataV2Query(baseOptions: Apollo.QueryHookOptions<FetchAiOnboardingModalDataV2Query, FetchAiOnboardingModalDataV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAiOnboardingModalDataV2Query, FetchAiOnboardingModalDataV2QueryVariables>(FetchAiOnboardingModalDataV2Document, withFetchPolicyContext(options));
      }
export function useFetchAiOnboardingModalDataV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAiOnboardingModalDataV2Query, FetchAiOnboardingModalDataV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAiOnboardingModalDataV2Query, FetchAiOnboardingModalDataV2QueryVariables>(FetchAiOnboardingModalDataV2Document, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchAiOnboardingModalDataV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAiOnboardingModalDataV2Query, FetchAiOnboardingModalDataV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAiOnboardingModalDataV2Query, FetchAiOnboardingModalDataV2QueryVariables>(FetchAiOnboardingModalDataV2Document, withFetchPolicyContext(options));
        }
export type FetchAiOnboardingModalDataV2QueryHookResult = ReturnType<typeof useFetchAiOnboardingModalDataV2Query>;
export type FetchAiOnboardingModalDataV2LazyQueryHookResult = ReturnType<typeof useFetchAiOnboardingModalDataV2LazyQuery>;
export type FetchAiOnboardingModalDataV2SuspenseQueryHookResult = ReturnType<typeof useFetchAiOnboardingModalDataV2SuspenseQuery>;
export type FetchAiOnboardingModalDataV2QueryResult = Apollo.QueryResult<FetchAiOnboardingModalDataV2Query, FetchAiOnboardingModalDataV2QueryVariables>;
export const FetchAiOnboardingModalAllSuggestionsV2Document = gql`
    query FetchAIOnboardingModalAllSuggestionsV2($householdID: ID!, $suggestionsWhere: AISuggestionWhereInput!) {
  aiSuggestions(
    where: {and: [{hasHouseholdWith: [{id: $householdID}], version: 2, kindNotIn: [ONBOARDING_INDIVIDUAL, ONBOARDING_ORGANIZATION]}, $suggestionsWhere]}
    orderBy: {field: created_at, direction: DESC}
  ) {
    edges {
      node {
        id
        ...AIOnboardingModal_AISuggestionFormData
        evidence {
          ...CommonAISuggestionEvidence
        }
      }
    }
  }
}
    ${AiOnboardingModal_AiSuggestionFormDataFragmentDoc}
${CommonAiSuggestionEvidenceFragmentDoc}`;

/**
 * __useFetchAiOnboardingModalAllSuggestionsV2Query__
 *
 * To run a query within a React component, call `useFetchAiOnboardingModalAllSuggestionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useFetchAiOnboardingModalAllSuggestionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAiOnboardingModalAllSuggestionsV2Query({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      suggestionsWhere: // value for 'suggestionsWhere'
 *   },
 * });
 */
export function useFetchAiOnboardingModalAllSuggestionsV2Query(baseOptions: Apollo.QueryHookOptions<FetchAiOnboardingModalAllSuggestionsV2Query, FetchAiOnboardingModalAllSuggestionsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAiOnboardingModalAllSuggestionsV2Query, FetchAiOnboardingModalAllSuggestionsV2QueryVariables>(FetchAiOnboardingModalAllSuggestionsV2Document, withFetchPolicyContext(options));
      }
export function useFetchAiOnboardingModalAllSuggestionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAiOnboardingModalAllSuggestionsV2Query, FetchAiOnboardingModalAllSuggestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAiOnboardingModalAllSuggestionsV2Query, FetchAiOnboardingModalAllSuggestionsV2QueryVariables>(FetchAiOnboardingModalAllSuggestionsV2Document, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchAiOnboardingModalAllSuggestionsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAiOnboardingModalAllSuggestionsV2Query, FetchAiOnboardingModalAllSuggestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAiOnboardingModalAllSuggestionsV2Query, FetchAiOnboardingModalAllSuggestionsV2QueryVariables>(FetchAiOnboardingModalAllSuggestionsV2Document, withFetchPolicyContext(options));
        }
export type FetchAiOnboardingModalAllSuggestionsV2QueryHookResult = ReturnType<typeof useFetchAiOnboardingModalAllSuggestionsV2Query>;
export type FetchAiOnboardingModalAllSuggestionsV2LazyQueryHookResult = ReturnType<typeof useFetchAiOnboardingModalAllSuggestionsV2LazyQuery>;
export type FetchAiOnboardingModalAllSuggestionsV2SuspenseQueryHookResult = ReturnType<typeof useFetchAiOnboardingModalAllSuggestionsV2SuspenseQuery>;
export type FetchAiOnboardingModalAllSuggestionsV2QueryResult = Apollo.QueryResult<FetchAiOnboardingModalAllSuggestionsV2Query, FetchAiOnboardingModalAllSuggestionsV2QueryVariables>;
export const FetchOnboardingPrincipalNodesDocument = gql`
    query FetchOnboardingPrincipalNodes($householdID: ID!, $nodeIDs: [ID!]!) {
  fetchHouseholdKGV2Nodes(input: {householdID: $householdID, nodeIDs: $nodeIDs}) {
    ...AIOnboardingModal_KGV2PrincipalNode
  }
}
    ${AiOnboardingModal_Kgv2PrincipalNodeFragmentDoc}`;

/**
 * __useFetchOnboardingPrincipalNodesQuery__
 *
 * To run a query within a React component, call `useFetchOnboardingPrincipalNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOnboardingPrincipalNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOnboardingPrincipalNodesQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      nodeIDs: // value for 'nodeIDs'
 *   },
 * });
 */
export function useFetchOnboardingPrincipalNodesQuery(baseOptions: Apollo.QueryHookOptions<FetchOnboardingPrincipalNodesQuery, FetchOnboardingPrincipalNodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOnboardingPrincipalNodesQuery, FetchOnboardingPrincipalNodesQueryVariables>(FetchOnboardingPrincipalNodesDocument, withFetchPolicyContext(options));
      }
export function useFetchOnboardingPrincipalNodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOnboardingPrincipalNodesQuery, FetchOnboardingPrincipalNodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOnboardingPrincipalNodesQuery, FetchOnboardingPrincipalNodesQueryVariables>(FetchOnboardingPrincipalNodesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchOnboardingPrincipalNodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchOnboardingPrincipalNodesQuery, FetchOnboardingPrincipalNodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchOnboardingPrincipalNodesQuery, FetchOnboardingPrincipalNodesQueryVariables>(FetchOnboardingPrincipalNodesDocument, withFetchPolicyContext(options));
        }
export type FetchOnboardingPrincipalNodesQueryHookResult = ReturnType<typeof useFetchOnboardingPrincipalNodesQuery>;
export type FetchOnboardingPrincipalNodesLazyQueryHookResult = ReturnType<typeof useFetchOnboardingPrincipalNodesLazyQuery>;
export type FetchOnboardingPrincipalNodesSuspenseQueryHookResult = ReturnType<typeof useFetchOnboardingPrincipalNodesSuspenseQuery>;
export type FetchOnboardingPrincipalNodesQueryResult = Apollo.QueryResult<FetchOnboardingPrincipalNodesQuery, FetchOnboardingPrincipalNodesQueryVariables>;